var map = {
	"./pin-in-0.svg": "2a44",
	"./pin-in-1.svg": "7349",
	"./pin-in-10.svg": "3f95",
	"./pin-in-2.svg": "f2d7",
	"./pin-in-3.svg": "fdd4",
	"./pin-in-4.svg": "780e",
	"./pin-in-5.svg": "626a",
	"./pin-in-6.svg": "b10c",
	"./pin-in-7.svg": "6acf",
	"./pin-in-8.svg": "b387",
	"./pin-in-9.svg": "7c39"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd20";